import React from 'react'
import locicon from '../images/contact/location_icon.svg';
import phone from '../images/contact/phone_icon.svg';
import mail from '../images/contact/mail_icon.svg';
import Link from 'next/link';
import facebook from '../images/contact/facebook_icon.svg';
import twitter from '../images/contact/twitter_icon.svg';
import linkin from '../images/contact/linkedin_icon.svg';
import whatsapp from '../images/contact/whatsapp_icon.svg';
import insta from '../images/contact/instagram_contact.svg';

import map from '../images/contact/map.jpg';
import Image from 'next/image';



const Contactcontet = () => {
  return (
    <div className=' w-full mx-auto'>
        <div className=' bg-ashgray1'>
            <div className=' container mx-auto max-w-screen-xl justify-center flex flex-col lg:flex-row'>
                <div className='flex w-full  lg:basis-1/2 justify-start items-start flex-col  py-5 p-3 lg:p-5 lg:py-5'>
                    <p className=' text-ashred text-2xl'>
                    Head Office
                    </p>
                    <div className='h-2'></div>
                    <ul className="list-none">
                    <li className="flex items-center"> <Image src={locicon} alt="Your Image" className="w-6 mr-2" /><div className=' text-2xl font-semibold'><span className='vollkorn-sc-semibold'>Ashlok</span> Safe Earthing Electrode Limited</div></li>
                    <li className="flex items-center"><div className='pl-8'>No. 58 | 3rd Street | North Phase | SIDCO Industrial Estate</div></li>
                    <li className="flex items-center"><div className='pl-8'> Ambattur | Chennai - 600 098 | Tamil Nadu | India.</div></li>
                    </ul>
                    <div className='h-5'></div>
                    <ul className="list-none">
                        <li className="flex items-center"> <Image src={phone} alt="Your Image" className="w-6 mr-2" /><div>+91 - 44 2625 4757</div></li>
                        <li className="flex items-center"><div className='pl-8'>+91 - 94440 87356</div></li>
                    </ul>
                    <div className='h-5'></div>
                    <ul className="list-none">
                        <li className="flex items-center"> <Image src={mail} alt="Your Image" className="w-6 mr-2" /><div>earthing@ashlok.com</div></li>
                       
                    </ul>
                    <div className='h-5'></div>
                  
                     <ul className="list-none">
                     <li className="flex items-center"> <Image src={locicon} alt="Your Image" className="w-6 mr-2" /><div className=' text-l font-semibold'>Manufacturing Unit(<span style={{fontSize:'90%'}}>s</span>) : Chennai | Ahmedabad</div></li>
                        </ul>
                    <div className='h-5'></div>
                    <ul className="list-none flex items-center   justify-center">
                        {/* <li className="flex items-center justify-center">
                             <Image src={facebook} alt="Your Image" className="mr-2" />  <Image src={linkin} alt="Your Image" className="mr-2 pl-5" /> <Image src={insta} alt="Your Image" className="mr-2 pl-5" /> <Image src={whatsapp} alt="Your Image" className="mr-2 pl-5" /></li> */}

                     <li>   <Link href="https://www.facebook.com/profile.php?id=100068589324482" target="_blank"><Image src={facebook} className='mr-2 w-[50%]' alt="Ashlok fb" /></Link>         </li>
                     <li>  <Link href="https://www.linkedin.com/company/8507004/admin/inbox/thread/2-YjM4ZmE3ZjYtYmJhMy00NjRkLTk0MzItNWQxNDYyNjViZTY2XzAxMA==" target="_blank"><Image src={linkin} className='mr-2 w-[50%]' alt="Ashlok linked in" /></Link>         </li> 
                     <li>  <Link href="https://www.instagram.com/ashlok_safe_earthing" target="_blank"><Image src={insta} className='mr-2 w-[50%]' alt="Ashlok Instagram" /></Link>   </li>       
     
                        

                    </ul>
                </div>
                <div className='flex w-full lg:basis-1/2 m-3 lg:m-1    lg:mx-3 justify-start lg:justify-end  items-start '>
                    <Image className=" max-w-[95%] lg:max-w-xl lg:my-5 border-2 border-gray-500" src={map} alt="Ashlok Safe Earthing Electrode Limited location map, Chennai, Tamil Nadu"/>
                </div>
            </div>
        </div>


        <div className=' flex justify-center max-w-4xl'>

           
        </div>
      
    </div>
  )
}
export default Contactcontet
